import { render, staticRenderFns } from "./SaleTitle.vue?vue&type=template&id=61f46d00&scoped=true"
import script from "./SaleTitle.vue?vue&type=script&lang=js"
export * from "./SaleTitle.vue?vue&type=script&lang=js"
import style0 from "./SaleTitle.vue?vue&type=style&index=0&id=61f46d00&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61f46d00",
  null
  
)

export default component.exports